export const DESKTOP_HEADER_HEIGHT = "5.3rem";
export const MOBILE_HEADER_HEIGHT = "6.8rem";
